import React, { useState, useEffect } from "react";
import { Box, Fade } from "@mui/material";

const ScrollToBottom = ({ containerRef, onClick, isMobileDisplay }) => {
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef?.current) return;

      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 250;
      setShowScrollToBottom(!isAtBottom);
    };

    const container = containerRef?.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [containerRef]);

  return (
    <Fade in={showScrollToBottom} mountOnEnter unmountOnExit container={containerRef?.current}>
      <Box
        sx={{
          position: "fixed",
          bottom: isMobileDisplay ? "7rem" : "2rem",
          left: "50%",
          transform: isMobileDisplay ? "translateX(-50%)" : "",
          backgroundColor: "#333",
          color: "#a8a8a8",
          borderRadius: "0.5rem",
          padding: "0.5rem 1rem",
          cursor: "pointer",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
          fontSize: "0.9rem",
          zIndex: 1000,
        }}
        onClick={onClick}
      >
        Scroll to Bottom
      </Box>
    </Fade>
  );
};

export default ScrollToBottom;
